module.exports = __webpack_public_path__ + "static/pergola-2-7f70427b6c500749da2234d30e6e3339.jpg";